module.exports = __webpack_public_path__ + "static/media/starofthesea.b5c20f38.webp";